import request from "../utils/request";

// let headersA = {
//   'token':localStorage.getItem('token')
// }

// 首页  轮播图
export function getHomepageBanner() {
  return request({
    url: "/banner/getHomepageBanner",
    method: "get",
  });
}

// 内页 banner
export function getInnerPageBanner() {
  return request({
    url: "/banner/getInnerPageBanner",
    method: "get",
  });
}

// 关于我们
export function getAboutUsInfo() {
  return request({
    url: "/aboutUs/getAboutUsInfo",
    method: "get",
  });
}

// 企业文化
export function getCorporateCulture() {
  return request({
    url: "/aboutUs/getCorporateCulture",
    method: "get",
  });
}

// 新闻动态
export function newsUpdatesList(params) {
  return request({
    url: "/newsUpdates/lists",
    method: "get",
    params,
  });
}

// 新闻动态
export function newsUpdatesDetail(params) {
  return request({
    url: "/newsUpdates/detail",
    method: "get",
    params
  });
}

// 获取联系我们信息
export function getContactUsInfo() {
  return request({
    url: "/contactUs/getContactUsInfo",
    method: "get",
  });
}

// 提交留言
export function submitMessageUs(data) {
  return request({
    url: "/contactUs/submitMessage",
    method: "post",
    data
  });
}

// 获取二维码
export function getQrCode() {
  return request({
    url: "/qrCode/getQrCode",
    method: "get",
  });
}


// 账号验证码登录
export function loginAccount(data) {
  return request({
    url: "/login/account",
    method: "post",
    data
  });
}
// 退出登录
export function loginLogout(data) {
  return request({
    url: "/login/logout",
    method: "post",
    data
  });
}
// 生成二维码登录
export function getScanCode(params) {
  return request({
    url: "/login/getScanCode",
    method: "get",
    params
  });
}
// 检测扫码状态
export function checkScanLoginQrcodeStatus(params) {
  return request({
    url: "/login/checkScanLoginQrcodeStatus",
    method: "get",
    params
  });
}
// 扫码授权登录
export function scanLogin(params) {
  return request({
    url: "/login/scanLogin",
    method: "get",
    params
  });
}
// 验证码
export function sendCode(data) {
  return request({
    url: "/sms/sendCode",
    method: "post",
    data
  });
}
// 验证码
export function policyIndex(params) {
  return request({
    url: "/index/policy",
    method: "get",
    params
  });
}


// 港口
export function validPortLists(params) {
  return request({
    url: "/baseData/validPortLists",
    method: "get",
    params
  });
}
// 信息类型
export function baseInfoType(params) {
  return request({
    url: "/baseData/baseInfoType",
    method: "get",
    params
  });
}
// 发布次数
export function baseInfoNumber(params) {
  return request({
    url: "/baseData/baseInfoNumber",
    method: "get",
    params
  });
}
// 间隔时间
export function baseInfoIntervalTime(params) {
  return request({
    url: "/baseData/baseInfoIntervalTime",
    method: "get",
    params
  });
}



// 信息大厅
export function driverInfoList(params) {
  return request({
    url: "/driverInfoList/lists",
    method: "get",
    params
  });
}
// 信息大厅
export function driverInfoDetail(params) {
  return request({
    url: "/driverInfoList/detail",
    method: "get",
    params
  });
}
// 信息大厅
export function searchKeyword(params) {
  return request({
    url: "/driverInfoList/searchKeyword",
    method: "get",
    params
  });
}
// 信息大厅
export function delKeyword(data) {
  return request({
    url: "/driverInfoList/delKeyword",
    method: "post",
    data
  });
}
// 信息大厅
export function clearKeyword(data) {
  return request({
    url: "/driverInfoList/clearKeyword",
    method: "post",
    data
  });
}
// 信息大厅
export function reportInfo(data) {
  return request({
    url: "/driverInfoList/report",
    method: "post",
    data
  });
}



// 信息 管理
export function listInfo(params) {
  return request({
    url: "/driverInfo/lists",
    method: "get",
    params
  });
}
// 信息 管理
export function detailInfo(params) {
  return request({
    url: "/driverInfo/detail",
    method: "get",
    params
  });
}
// 信息大厅
export function addInfo(data) {
  return request({
    url: "/driverInfo/add",
    method: "post",
    data
  });
}
// 信息大厅
export function editInfo(data) {
  return request({
    url: "/driverInfo/edit",
    method: "post",
    data
  });
}
// 信息大厅
export function setOnlineInfo(data) {
  return request({
    url: "/driverInfo/setOnline",
    method: "post",
    data
  });
}

// 信息大厅
export function getDriverQrCode() {
  return request({
    url: "/login/getDriverQrCode",
    method: "get",
  });
}